import React from "react";
import NavBar from "../../components/NavBar/NavBar";
import Gallery from "../../components/Gallery/Gallery";
import Footer from "../../components/Footer/Footer";
import ScrollButton from "../../components/ScrollButton/ScrollButton";

const NewCoversPage = () => {
  return (
    <>
      <NavBar></NavBar>
      <Gallery></Gallery>
      <ScrollButton></ScrollButton>
      <Footer></Footer>
    </>
  );
};

export default NewCoversPage;
